import { toRequest } from '../../utils/RequestUtils';
import { getApis } from './../../library/Apis';

export const RESETED_PROFESSORES = 'RESETED_PROFESSORES';
export const CHANGE_PROFESSOR_STATUS_ACTION = 'CHANGE_PROFESSOR_STATUS_ACTION';
export const LOADING_EDUCADORES_LIST = 'LOADING_EDUCADORES_LIST';
export const LOADED_EDUCADORES_ACTION = 'LOADED_EDUCADORES_ACTION';
export const CLEARED_EDUCADORES_ACTION = 'CLEARED_EDUCADORES_ACTION';
export const LOADING_PROFESSORES_LIST = 'LOADING_PROFESSORES_LIST';
export const LOADED_PROFESSORES_ACTION = 'LOADED_PROFESSORES_ACTION';
export const CLEARED_PROFESSORES_ACTION = 'CLEARED_PROFESSORES_ACTION';
export const LOADED_PROFESSOR_ACTION = 'LOADED_PROFESSOR_ACTION';
export const SAVED_PROFESSOR_ACTION = 'SAVED_PROFESSOR_ACTION';
export const CLEARED_PROFESSOR_ACTION = 'CLEARED_PROFESSOR_ACTION';
export const CLEARED_PROFESSORES_PAGE_ACTION =
  'CLEARED_PROFESSORES_PAGE_ACTION';
export const LOADED_PROFESSORES_PAGE_ACTION = 'LOADED_PROFESSORES_PAGE_ACTION';
export const CHANGED_PROFESSOR_EDITING_VALUE_ACTION =
  'CHANGED_PROFESSOR_EDITING_VALUE_ACTION';
export const REMOVING_PROFESSOR_ACTION = 'REMOVING_PROFESSOR_ACTION';
export const CLEARED_ALL_PROFESSOR_GESTOR_BY_ESCOLA =
  'CLEARED_ALL_PROFESSOR_GESTOR_BY_ESCOLA';
export const LOADING_ALL_PROFESSOR_GESTOR_BY_ESCOLA =
  'LOADING_ALL_PROFESSOR_GESTOR_BY_ESCOLA';
export const LOEADED_ALL_PROFESSOR_GESTOR_BY_ESCOLA =
  'LOEADED_ALL_PROFESSOR_GESTOR_BY_ESCOLA';
export const SET_INPUT_NAME = 'SET_INPUT_NAME';
export const SET_NAME = 'SET_NAME';
export const SET_PROFESSOR_NAME = 'SET_PROFESSOR_NAME';

export const setProfessorName = (name) => ({
  type: SET_PROFESSOR_NAME,
  payload: name,
});

export const setName = (nameType, nameValue) => ({
  type: SET_NAME,
  payload: {
    type: nameType,
    value: nameValue,
  },
});

const getEndpoint = () => {
  return getApis().apis.bff + 'v1/professor';
};

const getEducadoresEndpoint = () => {
  return getApis().apis.bff + 'v1/educador';
};

export const resetProfessoresReducer = () => ({
  type: RESETED_PROFESSORES,
  payload: null,
});

export const clearProfessorEditing = () => ({
  type: CLEARED_PROFESSOR_ACTION,
  payload: null,
});

export const changeProfessorEditingValue = (name, value) => {
  if (typeof value === 'string') {
    if (value.trim().length > 0) {
      return {
        type: CHANGED_PROFESSOR_EDITING_VALUE_ACTION,
        payload: { name, value },
      };
    } else {
      return {
        type: CHANGED_PROFESSOR_EDITING_VALUE_ACTION,
        payload: { name, value: '' },
      };
    }
  }
  return {
    type: CHANGED_PROFESSOR_EDITING_VALUE_ACTION,
    payload: { name, value },
  };
};

export const saveAutoCadastro = (professor, callbackSuccess, callbackError) => {
  return (dispatch) => {
    toRequest('put', [`${getEndpoint()}/auto`, professor], 'save').then(
      (resp) => {
        dispatch({
          type: SAVED_PROFESSOR_ACTION,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const saveProfessorByCPF = (
  professor,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    toRequest('put', [`${getEndpoint()}`, professor], 'save').then(
      (resp) => {
        dispatch({
          type: SAVED_PROFESSOR_ACTION,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadProfessorByCPF = (cpf, callbackSuccess, callbackError) => {
  return (dispatch) => {
    toRequest('get', [`${getEndpoint()}/${cpf}`], 'professor').then(
      (resp) => {
        dispatch({
          type: LOADED_PROFESSOR_ACTION,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const clearProfessores = () => ({
  type: CLEARED_PROFESSORES_ACTION,
  payload: null,
});

export const loadProfessores = (
  idEscola,
  professoresNecessarios,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_PROFESSORES_LIST,
      payload: true,
    });
    toRequest(
      'post',
      [`${getEndpoint()}/escola/${idEscola}`, professoresNecessarios],
      'professores'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_PROFESSORES_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_PROFESSORES_LIST,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_PROFESSORES_LIST,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadEducadores = (
  idEscola,
  codCoop,
  educadoresNecessarios,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_EDUCADORES_LIST,
      payload: true,
    });
    toRequest(
      'post',
      [
        `${getEducadoresEndpoint()}/educadores`,
        {
          idEscola: idEscola,
          codCoop: codCoop,
          educadoresNecessarios: educadoresNecessarios || [],
        },
      ],
      'professores'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_EDUCADORES_ACTION,
          payload: resp.data,
        });
        dispatch({
          type: LOADING_EDUCADORES_LIST,
          payload: false,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        dispatch({
          type: LOADING_EDUCADORES_LIST,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const clearProfessoresPageList = () => ({
  type: CLEARED_PROFESSORES_PAGE_ACTION,
  payload: null,
});

export const changeProfessorStatus = (
  cpf,
  status,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    toRequest(
      'put',
      [`${getEndpoint()}/${cpf}/status/${status}`],
      'save'
    ).then(
      () => {
        dispatch({
          type: CHANGE_PROFESSOR_STATUS_ACTION,
          payload: {
            cpf,
            status,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const deleteProfessor = (cpf, callbackSuccess, callbackError) => {
  return (dispatch) => {
    dispatch({
      type: REMOVING_PROFESSOR_ACTION,
      payload: true,
    });
    toRequest('delete', [`${getEndpoint()}/${cpf}`], 'save').then(
      (resp) => {
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: REMOVING_PROFESSOR_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const clearAllProfessorGestorByEscola = () => ({
  type: CLEARED_ALL_PROFESSOR_GESTOR_BY_ESCOLA,
  payload: null,
});

export const loadAllProfessorGestorByEscola = (
  idEscola,
  callbackError,
  callbackSuccess
) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_ALL_PROFESSOR_GESTOR_BY_ESCOLA,
      payload: true,
    });
    toRequest(
      'get',
      [`${getEndpoint()}/gestores/escola/${idEscola}`],
      'loadProfessorGestor'
    ).then(
      (resp) => {
        dispatch({
          type: LOADING_ALL_PROFESSOR_GESTOR_BY_ESCOLA,
          payload: false,
        });
        dispatch({
          type: LOEADED_ALL_PROFESSOR_GESTOR_BY_ESCOLA,
          payload: resp.data,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: LOADING_ALL_PROFESSOR_GESTOR_BY_ESCOLA,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadProfessoresPaginados = (
  postData,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    const ensureArray = (data) => (Array.isArray(data) ? data : []);
    postData.estados = ensureArray(postData.estados);
    postData.cidades = ensureArray(postData.cidades);
    postData.escolas = ensureArray(postData.escolas);
    const url = `${getEndpoint()}/page?page=${postData.page}&size=${
      postData.size
    }`;
    const { ...bodyData } = postData;
    toRequest('post', [url, bodyData], 'professoresPaginado').then(
      (resp) => {
        dispatch({
          type: LOADED_PROFESSORES_PAGE_ACTION,
          payload: {
            ...resp.data,
            busca: postData.busca,
            page: postData.page,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp.data);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};
